<script setup>
import IconBase from '../icon/IconBase.vue';
import IconPlus from '../icon/IconPlus.vue';
import IconMediaflowEmptyPlaceholderImage from '../icon/IconMediaflowEmptyPlaceholderImage.vue';
import FormButton from '../Atoms/FormButton.vue'
import EmptyState from '../ui/EmptyState.vue'

const emit = defineEmits({
  'createMediaflow': () => true,
  'showDemo': () => true,
})
const showCreateMediaflowModal = () => emit('createMediaflow')
const showDemo = () => emit('showDemo')
</script>

<template>
  <main>
    <EmptyState title="Your first Cloud Production">
      <template #illustration>
        <icon-base :width="128" :height="120" :width-view-box="128" :height-view-box="120">
          <icon-mediaflow-empty-placeholder-image />
        </icon-base>
      </template>
      <template #subtitle>
        Build flows from livestreams, videos, images and web pages, switch between them and go live. It runs on Castr's servers, so it keeps streaming after you close the browser.
      </template>
      <template #actions>
        <FormButton type="main" size="md" class="w-64 justify-center" data-testid="create-production" @click="showCreateMediaflowModal">
          <icon-base class="mr-2">
            <icon-plus />
          </icon-base>
          New Cloud Production
        </FormButton>
        <span class="flex items-center gap-3 text-xs text-surface-8">
          <FormButton type="link" size="sm" class="!px-0 text-xs text-main-light" href="https://docs.castr.com/en/articles/12310739-cloud-production-live-switching-made-simple">How it works</FormButton>
          <span aria-hidden="true">·</span>
          <FormButton type="link" size="sm" class="!px-0 text-xs text-main-light" @click="showDemo">Watch a tutorial</FormButton>
        </span>
      </template>
    </EmptyState>
  </main>
</template>
